import { useNavigationWidth } from 'features/navigation/hooks/useNavigationWidth'

export function useLeftOffset() {
    return useNavigationWidth()
}
